const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* WKT bot-traffic cleanup: block only confirmed orphaned external loaders. */
(() => {
  const blockedScriptPrefixes = ['https://api.arvow.com/'];
  const blockedFetchPrefixes = ['https://dashboard.shrinetheme.com/api/updates/check'];

  const originalAppendChild = Node.prototype.appendChild;
  Node.prototype.appendChild = function appendChildWithTrafficGuard(child) {
    const isBlockedScript =
      child instanceof HTMLScriptElement &&
      typeof child.src === 'string' &&
      blockedScriptPrefixes.some((prefix) => child.src.startsWith(prefix));

    if (isBlockedScript) {
      console.info('[WKT cleanup] Blocked orphaned external script:', child.src);
      return child;
    }

    return originalAppendChild.call(this, child);
  };

  const originalFetch = window.fetch.bind(window);
  window.fetch = function fetchWithTrafficGuard(resource, options) {
    const requestUrl =
      typeof resource === 'string'
        ? resource
        : resource && typeof resource.url === 'string'
          ? resource.url
          : '';

    const isBlockedFetch = blockedFetchPrefixes.some((prefix) => requestUrl.startsWith(prefix));

    if (isBlockedFetch) {
      console.info('[WKT cleanup] Blocked orphaned external request:', requestUrl);
      return Promise.resolve(new Response(null, { status: 204, statusText: 'Blocked by WKT cleanup' }));
    }

    return originalFetch(resource, options);
  };
})();
